<template>
  <v-card>
    <div class="popped-card-small-outer">
      <v-card
        :class="item.color"
        class="elevation-7 popped-card-small-inner"
        ripple
        router
        :to="{name: item.link}"
      >
        <div>
          <v-card-title class="text-xs-center popped-icon-small">
            <v-icon size="72px">{{item.icon}}</v-icon>
          </v-card-title>
        </div>
      </v-card>
    </div>
    <div class="popped-card-small-text text-xs-right">
      <v-card-title primary-title>
        <v-spacer></v-spacer>
        <div>
          <h3 class="title font-weight-regular mb-2">{{item.title}}</h3>
          <p class="font-weight-light grey--text">{{item.content}}</p>
        </div>
      </v-card-title>
    </div>

    <div class="card-divider grey lighten-2"></div>

    <div class="card-footer grey--text">
      <v-icon small color="grey" class="mr-2">{{item.icon}}</v-icon>
      {{count}} total {{item.link}}s
      <!-- <time-ago class="grey--text" time="1541526314603" updated>
                <v-icon small color="grey" slot="icon" class="mr-2">
                    access_time
                </v-icon>
      </time-ago>-->
    </div>
  </v-card>
</template>

<script>
import StatisticsService from "@/services/requests/statisticsService";
export default {
  data() {
    return {
      count: null
    };
  },
  props: {
    item: Object
  },
  methods: {
    getCount() {
      StatisticsService.countMasterFile(this.item.link).then(result => {
        this.count = result.data.result;
      });
    }
  },
  mounted() {
    this.getCount();
  }
};
</script>

<style scoped>
.popped-card-small-outer {
  padding-left: 15px;
  top: -20px;
  top: -20px !important;
  margin-bottom: -20px !important;
  position: absolute;
}

.popped-card-small-inner {
  border-radius: 6px;
  border-top-left-radius: 6px !important;
  border-top-right-radius: 6px !important;
}

.popped-card-small-text {
  margin-left: 120px;
}

.card-footer {
  padding: 0px 16px 10px 16px;
}

.card-divider {
  height: 1px;
  margin: 10px 20px;
}
</style>
